'use client';

import React from 'react';
import Image from 'next/image';
import {
  SidebarProvider,
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarInset,
  SidebarFooter,
} from '@/components/ui/sidebar';
import SidebarNav from '@/components/layout/sidebar-nav';
import SidebarThemeToggle from '../ui/sidebar-theme-toggle';
import { useTranslations } from 'next-intl';

type AppShellProps = {
  children: React.ReactNode;
};

const AppShell: React.FC<AppShellProps> = ({ children }) => {
  const t = useTranslations();

  return (
    <SidebarProvider>
      <div className="grid h-screen w-full overflow-hidden md:grid-cols-[16rem_1fr]">
        <Sidebar variant="sidebar" collapsible="icon" className="z-40">
          <SidebarHeader className="h-14 lg:h-[60px]">
            <div className="flex items-center gap-2 px-2 font-semibold">
              {/* Logo */}
              <Image
                src="/logo.png"
                alt="TradeAte"
                width={28}
                height={28}
                priority
                className="shrink-0 object-contain"
              />

              {/* App Name – wird bei Icon-Collapse automatisch ausgeblendet */}
              <span className="truncate">
                {t('common.appName')}
              </span>
            </div>
          </SidebarHeader>

          <SidebarContent>
            <SidebarNav />
          </SidebarContent>

          <SidebarFooter>
            <SidebarThemeToggle />
          </SidebarFooter>
        </Sidebar>

        <div className="flex flex-col overflow-y-auto">
          <SidebarInset>{children}</SidebarInset>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default AppShell;
